import { Typography, withStyles } from "@material-ui/core";

const ErrorText = withStyles((theme) => ({
  root: {
    color: theme.palette.error.main,
  },
}))(Typography);

export default ErrorText;
